import cloneDeep from 'lodash.clonedeep';
import set from 'lodash.set';

import types from './constants';
import { states } from '../../values/enums';
import reportReducers from '../reducers';

const defaultReducer = (state, action) => (state)

const reportPending = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'report.status', {type: states.PENDING})
  set(next, 'report.data', null)
  return next
}

const reportComplete = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'report.status', {type: states.COMPLETE})
  set(next, 'report.data', action.report)
  return next
}

const reportError = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'report.status', {type: states.ERROR, data: action.error})
  return next
}

const setPrintLanguage = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'printLanguage', action.language)
  return next
}

const actionReducer = Object.assign({
  [types.PARENT_PENDING]: reportPending,
  [types.PARENT_COMPLETE]: reportComplete,
  [types.PARENT_ERROR]: reportError,
  [types.SET_PRINT_LANGUAGE]: setPrintLanguage,
}, reportReducers);

export default (state = {}, action = {type: null}) => {
  const reducer = actionReducer[action.type] || defaultReducer
  return reducer(state, action)
}